{
  "Absent": "Absent",
  "Absent / no activity": "Absent / pas d'activité",
  "Accepted": "Acceptée",
  "Account and preferences": "Compte et préférences",
  "Active": "Actif",
  "Actual system proven in operational environment": "Système réel prouvé en environnement opérationnel",
  "Administration": "Administration",
  "Assignment": "Affectation",
  "Assignment ended": "Fin d'affectation",
  "Auto": "Auto",
  "Automatic (rule)": "Automatique (règle)",
  "Basic principles observed": "Principes de base observés",
  "Blockers, risks, needs (optional).": "Blocages, risques, besoins (facultatif).",
  "Cancelled": "Annulée",
  "Checked: the section counts as filed.": "Coché : la section compte comme rendue.",
  "Claude (MCP)": "Claude (MCP)",
  "Closed": "Clos",
  "DAR decision": "Décision de la DAR",
  "Dark": "Sombre",
  "Done": "Réalisé",
  "Draft": "Brouillon",
  "Experimental proof of concept": "Preuve de concept expérimentale",
  "Failed": "Échec",
  "Forced in": "Forcé dedans",
  "Forced out": "Forcé dehors",
  "Friday": "vendredi",
  "Integrations": "Intégrations",
  "Interface": "Interface",
  "Interface theme": "Thème de l'interface",
  "Join": "Rejoindre",
  "Language": "Langue",
  "Leave": "Quitter",
  "Light": "Clair",
  "Links changed": "Liens modifiés",
  "Manual": "Manuelle",
  "Member": "Membre",
  "Missing": "Manquant",
  "Monday": "lundi",
  "My report": "Mon CRA",
  "My requests": "Mes demandes",
  "My space": "Mon espace",
  "Paused": "En pause",
  "Pending": "En attente",
  "People": "Personnes",
  "Planned": "Prévu",
  "Points of attention": "Points d'attention",
  "Project created": "Projet créé",
  "Project updated": "Projet modifié",
  "Projects": "Projets",
  "Refused": "Refusée",
  "Report compliance": "Conformité CRA",
  "Request cancelled": "Demande annulée",
  "Request pending": "Demande en attente",
  "Request to join": "Demande pour rejoindre",
  "Request to leave": "Demande pour quitter",
  "Requests": "Demandes",
  "Running": "En cours",
  "Saturday": "samedi",
  "Scheduled": "Planifiée",
  "Scheduled job": "Tâche planifiée",
  "Settings": "Paramètres",
  "Show or hide navigation": "Afficher ou masquer la navigation",
  "Sign out": "Se déconnecter",
  "Status changed": "Statut modifié",
  "Stream added": "Stream ajouté",
  "Stream archived": "Stream archivé",
  "Stream updated": "Stream modifié",
  "Submitted": "Soumis",
  "Succeeded": "Réussie",
  "Sunday": "dimanche",
  "System complete and qualified": "Système complet et qualifié",
  "System prototype demonstrated in operational environment": "Démonstration du prototype en environnement opérationnel",
  "TL/PO appointed": "TL/PO nommés",
  "Team reports": "CRA de l'équipe",
  "Technology concept formulated": "Concept technologique formulé",
  "Technology demonstrated in relevant environment": "Technologie démontrée en environnement représentatif",
  "Technology validated in lab": "Technologie validée en laboratoire",
  "Technology validated in relevant environment": "Technologie validée en environnement représentatif",
  "Thursday": "jeudi",
  "Tuesday": "mardi",
  "Wednesday": "mercredi",
  "Week {{number}} · {{span}}": "Semaine {{number}} · {{span}}",
  "What is planned for the following week.": "Ce qui est prévu la semaine suivante.",
  "What was done on the project this week.": "Ce qui a été fait cette semaine sur le projet.",
  "W{{number}} · {{span}}": "S{{number}} · {{span}}",
  "missing reports": "CRA manquants",
  "pending requests": "demandes en attente",
  "{{day}} at {{time}}": "{{day}} à {{time}}"
}
